<template>
  <div class="block">
    <el-button @click="saveAsExcel">导出excel</el-button>
  </div>
</template>

<script>
(function() {
  Object.setPrototypeOf =
    Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);

  function setProtoOf(obj, proto) {
    obj.__proto__ = proto;
    return obj;
  }

  function mixinProperties(obj, proto) {
    for (const prop in proto) {
      if (!obj.hasOwnProperty(prop)) {
        obj[prop] = proto[prop];
      }
    }
    return obj;
  }
})();

require("core-js/modules/es.object.assign");
require("core-js/modules/es.object.keys");
require("regenerator-runtime/runtime");
require("core-js/modules/es.object.values");
require("core-js/modules/es.object.set-prototype-of");
require("core-js/modules/es.array.find");
require("core-js/modules/es.array-buffer.is-view");
require("core-js/modules/es.weak-map");
require("core-js/modules/es.promise");
const ExcelJS = require("exceljs");
import { saveAs } from "file-saver";

export default {
  data() {
    return {};
  },
  methods: {
    async saveAsExcel() {
      // this.$confirm("确定保存该分支信息吗？", "确认信息", {
      //   distinguishCancelAndClose: true,
      //   confirmButtonText: "保存",
      //   cancelButtonText: "取消"
      // });
      const wb = new ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("页签第一页");
      const page1Row1 = ws1.addRow(["a", "b", "c"]);
      ws1.addRow([" aa", "bb", "bb"]);
      ws1.addRow(["  aaa", "bbb", "ccc"]);
      // console.log("page1Row1");
      // console.log(page1Row1);
      page1Row1.font = { bold: true, color: { argb: "00489A" } };
      page1Row1.fill = { color: { argb: "000000" } };
      const ws2 = wb.addWorksheet("页签第二页");
      const page2Row1 = ws2.addRow(["a", "b", "c"]);
      // console.log(page2Row1);
      page2Row1.font = { bold: true, color: { argb: "E65D6E" } };
      const buf = await wb.xlsx.writeBuffer();
      saveAs(new Blob([buf]), "abc.xlsx");
    }
  }
};
</script>
